import { compose, lifecycle } from 'coact/recompose'

import { Html5Qrcode } from 'html5-qrcode'

const container = compose(
  lifecycle({
    componentDidMount() {
      this.scanner = new Html5Qrcode('html5qr-code-full-region')
      const cameraConfig = { facingMode: 'environment' }
      const scanConfg = {}
      this.scanner
        .start(
          cameraConfig,
          scanConfg,
          async code => {
            console.log('read', code)
            this.props.onScanResult(code)
            await this.scanner.stop()
            this.scanner.clear()
            this.props.closeScanner()
          },
          () => {
            // Scanning: the per-frame failure callback is required positionally,
            // and a frame with no code in it is not an error worth reporting.
          },
        )
        .catch(() => {
          this.scanner.clear()
        })
    },
    componentWillUnmount() {
      if (this.scanner && this.scanner.getState() === 2) {
        this.scanner
          .stop()
          .then(() => {
            this.scanner.clear()
          })
          .catch(console.error)
      }
    },
  }),
)

export default container
